import { toLower } from 'lodash-es';
import z from 'zod';

import type {
  AuthActionControllerCreateData,
  AuthActionControllerFindAllResponse,
  UserControllerMeResponse,
} from '~/api';
import { zAuthActionControllerCreateData, zCreateInviteDto, zLoginDto, zUserControllerUpdateData } from '~/api/zod.gen';
import { ALLOWED_IMAGE_MIME_TYPES, MAX_FILE_SIZE } from '~/constants/other';

export const EmailPasswordParamsSchema = zLoginDto.extend({
  email: zLoginDto.shape.email.email('invalidEmail'),
  password: zLoginDto.shape.password.min(2, 'passwordTooShort'),
});

export type User = UserControllerMeResponse['data'];
export type Invite = AuthActionControllerFindAllResponse['data']['items'][number];
export type UserRole = AuthActionControllerCreateData['body']['role'];
export const ROLE_ENUM = zAuthActionControllerCreateData.shape.body.shape.role;

export const rolesOptions = ROLE_ENUM.options
  .filter(r => r !== 'DEVELOPER')
  .map(role => ({ label: `roles.${toLower(role)}`, value: role }));

export const inviteUserSchema = zCreateInviteDto.extend({ email: zLoginDto.shape.email.email('invalidEmail') });
export const updateUserSchema = zUserControllerUpdateData.shape.body.omit({ avatar: true, scope: true }).extend({
  scope: z.array(z.string()).default([]),
  avatar: z
    .instanceof(File)
    .refine(file => file.size <= MAX_FILE_SIZE, { message: 'invalidFileSize' })
    .refine(file => ALLOWED_IMAGE_MIME_TYPES.includes(file.type), { message: 'invalidFileType' })
    .optional(),
});

export type InviteUserParams = z.infer<typeof inviteUserSchema>;
export type UpdateUserParams = z.infer<typeof updateUserSchema>;
